import { FeatureMap } from '@/app/@types/featureMap';
import { UrlPath } from '@/app/@types/urlPath';
import { IResources } from '@/app/models/user';

// TODO: Existe rotas não mapeadas como de blocos e etc, pensar em como deixar isso mais facil de manter
const featuresKeys: Partial<Record<FeatureMap, UrlPath>> = {
  EPROD: '/$programId/eprod',
  'DECUPAGEM-ARTE': '/$programId/decupagens/arte',
  'DECUPAGEM-BASICA': '/$programId/decupagens/basica',
  'DECUPAGEM-FIGURINO': '/$programId/decupagens/figurino',
  INDISPONIBILIDADE: '/$programId/indisponibilidade-de-elenco',
  'PLANEJAMENTO-ROTEIRO': '/$programId/planejamento-de-roteiros',
  'DECUPAGEM-CONTINUIDADE': '/$programId/decupagens/continuidade',
  'DECUPAGEM-EFEITOS-ESPECIAIS': '/$programId/decupagens/efeitos',
  'CAPITULOS-E-CENAS': '/$programId/capitulos-e-cenas',
  VISOES: '/$programId/visoes',
  'ROTEIROS-SEMANA': '/$programId/roteiros-da-semana',
  GALERIA: '/$programId/fotos',
  RELATORIO: '/$programId/relatorios',
};

const allowedByDefault: IResources[] = [
  { path: '/', permissions: ['ESCRITA', 'LEITURA'] },
  { path: '/inicio', permissions: ['ESCRITA', 'LEITURA'] },
  { path: '/$programId/indicadores', permissions: ['ESCRITA', 'LEITURA'] },
];

export { featuresKeys, allowedByDefault };
